import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { CartContext } from "./CartContext";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

const Shop = () => {
  const data = [
    {
      id: 1,
      name: "Apple",
      category: "Fruits",
      price: 120,
      unit: "kg",
      images: [
        "https://picsum.photos/seed/apple/200",
        "https://picsum.photos/seed/banana/200",
        "https://picsum.photos/seed/orange/200"
      ]
    },
    { id: 2, name: "Banana", category: "Fruits", price: 60, unit: "dozen", images: ["https://picsum.photos/seed/banana/200" ]},
    { id: 3, name: "Orange", category: "Fruits", price: 90, unit: "kg", images: ["https://picsum.photos/seed/orange/200"]},
    { id: 4, name: "Mango", category: "Fruits", price: 150, unit: "kg", images: ["https://picsum.photos/seed/mango/200" ]},
    { id: 5, name: "Tomato", category: "Vegetables", price: 40, unit: "kg", image: "https://picsum.photos/seed/tomato/200" },
    { id: 6, name: "Potato", category: "Vegetables", price: 30, unit: "kg", image: "https://picsum.photos/seed/potato/200" },
    { id: 7, name: "Onion", category: "Vegetables", price: 50, unit: "kg", image: "https://picsum.photos/seed/onion/200" },
    { id: 8, name: "Carrot", category: "Vegetables", price: 60, unit: "kg", image: "https://picsum.photos/seed/carrot/200" },
    { id: 9, name: "Cabbage", category: "Vegetables", price: 40, unit: "kg", image: "https://picsum.photos/seed/cabbage/200" },
    { id: 10, name: "Broccoli", category: "Vegetables", price: 80, unit: "kg", image: "https://picsum.photos/seed/broccoli/200" },
    { id: 11, name: "Milk", category: "Dairy", price: 55, unit: "liter", image: "https://picsum.photos/seed/milk/200" },
    { id: 12, name: "Cheese", category: "Dairy", price: 250, unit: "kg", image: "https://picsum.photos/seed/cheese/200" },
    { id: 13, name: "Butter", category: "Dairy", price: 200, unit: "kg", image: "https://picsum.photos/seed/butter/200" },
    { id: 14, name: "Curd", category: "Dairy", price: 80, unit: "kg", image: "https://picsum.photos/seed/curd/200" },
    { id: 15, name: "Bread", category: "Bakery", price: 40, unit: "pack", image: "https://picsum.photos/seed/bread/200" },
    { id: 16, name: "Eggs", category: "Poultry", price: 70, unit: "dozen", image: "https://picsum.photos/seed/eggs/200" },
    { id: 17, name: "Chicken", category: "Meat", price: 220, unit: "kg", image: "https://picsum.photos/seed/chicken/200" },
    { id: 18, name: "Fish", category: "Meat", price: 300, unit: "kg", image: "https://picsum.photos/seed/fish/200" },
    { id: 19, name: "Rice", category: "Grains", price: 70, unit: "kg", image: "https://picsum.photos/seed/rice/200" },
    { id: 20, name: "Wheat Flour", category: "Grains", price: 50, unit: "kg", image: "https://picsum.photos/seed/flour/200" },
    { id: 21, name: "Sugar", category: "Essentials", price: 45, unit: "kg", image: "https://picsum.photos/seed/sugar/200" },
    { id: 22, name: "Salt", category: "Essentials", price: 25, unit: "kg", image: "https://picsum.photos/seed/salt/200" },
    { id: 23, name: "Cooking Oil", category: "Essentials", price: 180, unit: "liter", image: "https://picsum.photos/seed/oil/200" },
    { id: 24, name: "Tea Powder", category: "Beverages", price: 500, unit: "kg", image: "https://picsum.photos/seed/tea/200" },
    { id: 25, name: "Coffee", category: "Beverages", price: 600, unit: "kg", image: "https://picsum.photos/seed/coffee/200" },
    { id: 26, name: "Biscuits", category: "Snacks", price: 30, unit: "pack", image: "https://picsum.photos/seed/biscuits/200" },
    { id: 27, name: "Chips", category: "Snacks", price: 20, unit: "pack", image: "https://picsum.photos/seed/chips/200" },
    { id: 28, name: "Ketchup", category: "Condiments", price: 120, unit: "bottle", image: "https://picsum.photos/seed/ketchup/200" },
    { id: 29, name: "Honey", category: "Condiments", price: 350, unit: "bottle", image: "https://picsum.photos/seed/honey/200" },
    { id: 30, name: "Detergent", category: "Household", price: 150, unit: "kg", image: "https://picsum.photos/seed/detergent/200" }
  ];

  // Order Posting to Json Server

  const [name, setName] = useState("")
  const [mobile, setMobile] = useState("")
  const [address, setAddress] = useState("")

  const submitHandler = (e) => {
    e.preventDefault();

    // Prepare order data
    const orderData = {
      name,
      mobile,
      address,
      items: cart, // ✅ send all cart items
      total: totalPrice, // ✅ send total price
      date: new Date().toLocaleString(), // optional: store order date
    };

    axios.post("http://localhost:4000/Orders", orderData)
      .then((res) => {
        alert("Order placed successfully!");
        setCart([]); // ✅ clear cart after successful order
        setName("");
        setMobile("");
        setAddress("");
      })
      .catch((err) => alert("Error sending order!"));
  };

  // ✅ Global cart context
  const { cart, addToCart, decreaseQty, removeFromCart, totalPrice, setCart } =
    useContext(CartContext);



  // const [data, setData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");

  const [orderItem, setOrderItem] = useState(null);

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  // useEffect(()=>{
  //         axios.get(`http://localhost:4000/items`)
  //             .then((res)=>setData(res.data))
  //             .catch((err)=> console.log(err))
  //     })

  const categories = ["All", ...new Set(data.map((item) => item.category))];

  const filteredData =
    selectedCategory === "All" ? data : data.filter((item) => item.category === selectedCategory);


  return (
    <div className="container-fluid shop">
      <h1 className="text-center p-3">Welcome to Shopping</h1>

      {/* Dropdown + Cart Row */}
      <div className="d-flex justify-content-between align-items-center mb-4 px-4 sticky">
        {/* Dropdown */}
        <div className="dropdown">
          <button
            className="btn btn-success dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Select Category : {selectedCategory}
          </button>
          <ul className="dropdown-menu text-center" aria-labelledby="dropdownMenuButton">
            {categories.map((cat) => (
              <li key={cat}>
                <button className="dropdown-item" onClick={() => setSelectedCategory(cat)}>
                  {cat}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Cart beside dropdown */}
        <div className="cart-box">
          <button
            className="btn btn-success position-relative"
            data-bs-toggle="offcanvas"
            data-bs-target="#cartSidebar"
          >
            🛒 Cart
            {cart.length > 0 && (
              <span className="badge bg-danger rounded-pill position-absolute top-0 start-100 translate-middle">
                {cart.reduce((sum, i) => sum + i.qty, 0)}
              </span>
            )}
          </button>
        </div>
      </div>

    {/* Product Cards */}
<div className="row">
  {filteredData.map((item) => {
    const inCart = cart.find((i) => i.id === item.id);

    // ✅ Normalize images (always an array)
    const images = item.images ? item.images : [item.image];

    return (
      <div key={item.id} className="col-md-3 mb-3">

        {/* Desktop / Tablet View (default) */}
        <div className="card h-100 p-3 m-3 bg-white rounded text-center d-none d-sm-flex flex-column">
          {/* ✅ Carousel with Zoom */}
          <div id={`carousel-${item.id}`} className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-inner">
              {images.map((img, index) => (
                <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
                  <Zoom>
                    <img
                      src={img}
                      alt={`${item.name}-${index}`}
                      className="w-100 h-50 p-3"
                      style={{ objectFit: "contain", cursor: "zoom-in" }}
                    />
                  </Zoom>
                </div>
              ))}
            </div>

            <button className="carousel-control-prev" type="button" data-bs-target={`#carousel-${item.id}`} data-bs-slide="prev">
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target={`#carousel-${item.id}`} data-bs-slide="next">
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
            </button>
          </div>

          {/* ✅ Thumbnails (Desktop) */}
          {images.length > 1 && (
            <div className="d-flex justify-content-center mt-2 gap-2 flex-wrap">
              {images.map((thumb, idx) => (
                <img
                  key={idx}
                  src={thumb}
                  alt={`thumb-${idx}`}
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "cover",
                    cursor: "pointer",
                    border: idx === 0 ? "2px solid #198754" : "1px solid #ccc",
                    borderRadius: "5px"
                  }}
                  onClick={() =>
                    document.querySelector(`#carousel-${item.id}`)?.querySelectorAll(".carousel-item")[idx]?.classList.add("active")
                  }
                  data-bs-target={`#carousel-${item.id}`}
                  data-bs-slide-to={idx}
                />
              ))}
            </div>
          )}

          <div className="card-body d-flex flex-column justify-content flex-grow-1">
            <div>
              <h2 className="text-danger product">{item.name}</h2>
              <h4>Category: {item.category}</h4>
              <h4>Price: ₹{item.price}</h4>
              <h4>Unit: {item.unit}</h4>
            </div>
            <div className="mt-3">
              <button className="btn btn-success mb-2 w-100" onClick={() => addToCart(item)}>
                Add to Cart
              </button>
              {inCart && (
                <div className="d-flex justify-content-center align-items-center gap-2">
                  <button className="btn btn-outline-danger btn-sm" onClick={() => decreaseQty(item)}>–</button>
                  <span>{inCart.qty}</span>
                  <button className="btn btn-outline-success btn-sm" onClick={() => addToCart(item)}>+</button>
                </div>
              )}
              <button
                className="btn btn-success mt-2 w-100"
                data-bs-toggle="modal"
                data-bs-target="#orderModal"
                onClick={() => setOrderItem(item)}
              >
                Order Now
              </button>
            </div>
          </div>
        </div>

        {/* Mobile View */}
        <div className="card p-2 m-2 bg-white rounded d-flex flex-row align-items-stretch d-sm-none h-100">
          {/* ✅ Mobile Carousel with Zoom */}
          <div id={`carousel-mobile-${item.id}`} className="carousel slide me-2" style={{ width: "120px" }}>
            <div className="carousel-inner">
              {images.map((img, index) => (
                <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
                  <Zoom>
                    <img
                      src={img}
                      alt={`${item.name}-${index}`}
                      className="rounded h-100 w-100"
                      style={{ objectFit: "cover", cursor: "zoom-in" }}
                    />
                  </Zoom>
                </div>
              ))}
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target={`#carousel-mobile-${item.id}`} data-bs-slide="prev">
              <span className="carousel-control-prev-icon" style={{ width: "20px", height: "20px" }}></span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target={`#carousel-mobile-${item.id}`} data-bs-slide="next">
              <span className="carousel-control-next-icon" style={{ width: "20px", height: "20px" }}></span>
            </button>

            {/* ✅ Thumbnails (Mobile - vertical beside carousel) */}
            {images.length > 1 && (
              <div className="d-flex flex-row gap-1 mt-2">
                {images.map((thumb, idx) => (
                  <img
                    key={idx}
                    src={thumb}
                    alt={`thumb-mobile-${idx}`}
                    style={{
                      width: "40px",
                      height: "40px",
                      objectFit: "cover",
                      cursor: "pointer",
                      border: idx === 0 ? "2px solid #198754" : "1px solid #ccc",
                      borderRadius: "5px"
                    }}
                    data-bs-target={`#carousel-mobile-${item.id}`}
                    data-bs-slide-to={idx}
                  />
                ))}
              </div>
            )}
          </div>

          {/* Content */}
          <div className="card-body d-flex flex-column justify-content-between flex-grow-1 text-start p-2">
            <div>
              <h6 className="text-danger">{item.name}</h6>
              <p className="mb-1">Category: {item.category}</p>
              <p className="mb-1">₹{item.price} / {item.unit}</p>
            </div>

            <div className="d-flex justify-content-between align-items-center gap-2 mt-2">
              {!inCart ? (
                <button className="btn btn-success btn-sm flex-fill" onClick={() => addToCart(item)}>
                  Add to cart
                </button>
              ) : (
                <div className="d-flex align-items-center border rounded px-2 py-1 flex-fill justify-content-between">
                  <button className="btn btn-outline-danger btn-sm" onClick={() => decreaseQty(item)}>–</button>
                  <span>{inCart.qty}</span>
                  <button className="btn btn-outline-success btn-sm" onClick={() => addToCart(item)}>+</button>
                </div>
              )}

              <button
                className="btn btn-primary btn-sm flex-fill"
                data-bs-toggle="modal"
                data-bs-target="#orderModal"
                onClick={() => setOrderItem(item)}
              >
                Order
              </button>
            </div>
          </div>
        </div>

      </div>
    );
  })}
</div>



      {/* Cart Sidebar (Offcanvas) */}
      <div className="offcanvas offcanvas-end" tabIndex={-1} id="cartSidebar" aria-labelledby="cartSidebarLabel">
        <div className="offcanvas-header">
          <h5 id="cartSidebarLabel">🛒 Your Cart</h5>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas"></button>
        </div>
        <div className="offcanvas-body">
          {cart.length === 0 ? (
            <p>Your cart is empty</p>
          ) : (
            <>
              <ul className="list-group mb-3">
                {cart.map((item) => (
                  <li
                    key={item.id}
                    className="list-group-item d-flex justify-content-between align-items-center"
                  >
                    <div>
                      {item.name} - ₹{item.price} x {item.qty} {item.unit} ={" "}
                      <strong>₹{item.price * item.qty}</strong>
                    </div>
                    <div className="d-flex gap-2 align-items-center">
                      <button className="btn btn-outline-danger btn-sm" onClick={() => decreaseQty(item)}>
                        –
                      </button>
                      <span>{item.qty}</span>
                      <button className="btn btn-outline-success btn-sm" onClick={() => addToCart(item)}>
                        +
                      </button>
                      <button className="btn btn-outline-dark btn-sm" onClick={() => removeFromCart(item.id)}>
                        ❌
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
              <h5 className="text-end">Total: ₹{totalPrice}</h5>
              <button
                className="btn btn-success w-100 mt-2"
                data-bs-toggle="modal"
                data-bs-target="#orderModal"
                onClick={() => setOrderItem(null)}
              >
                Order Now
              </button>
            </>
          )}
        </div>
      </div>



      {/* Order Modal */}
      <div className="modal fade" id="orderModal" tabIndex="-1" aria-labelledby="orderModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            {/* Header */}
            <div className="modal-header">
              <h5 className="modal-title" id="orderModalLabel">
                {orderItem ? `Order ${orderItem.name}` : "Send Order Details for Your Cart"}
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            {/* Body */}
            <div className="modal-body">
              <form id="orderForm" onSubmit={submitHandler} >
                <div className="mb-3">
                  <label className="form-label">Your Name</label>
                  <input type="text" className="form-control" onChange={(e) => setName(e.target.value)} name="name" required />
                </div>
                <div className="mb-3">
                  <label className="form-label">Phone</label>
                  <input type="tel" className="form-control" onChange={(e) => setMobile(e.target.value)} name="phone" required />
                </div>
                <div className="mb-3">
                  <label className="form-label">Address</label>
                  <textarea className="form-control" onChange={(e) => setAddress(e.target.value)} name="address" rows="4" required></textarea>
                </div>

                {/* ✅ Single Item Order */}
                {orderItem && (
                  <div className="border rounded p-2 mb-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <strong>{orderItem.name}</strong> <br />
                        Price: ₹{orderItem.price}
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm"
                          onClick={() => decreaseQty(orderItem)}
                        >
                          –
                        </button>
                        <span>{cart.find((i) => i.id === orderItem.id)?.qty || 0}</span>
                        <button
                          type="button"
                          className="btn btn-outline-success btn-sm"
                          onClick={() => addToCart(orderItem)}
                        >
                          +
                        </button>
                      </div>
                    </div>
                    <div className="text-end mt-2">
                      <strong>
                        Subtotal: ₹
                        {(cart.find((i) => i.id === orderItem.id)?.qty || 0) * orderItem.price}
                      </strong>
                    </div>
                  </div>
                )}

                {/* ✅ Cart Items (if ordering whole cart) */}
                {!orderItem && cart.length > 0 && (
                  <div>
                    <h6>Items in Cart:</h6>
                    <ul className="list-group mb-3">
                      {cart.map((item) => (
                        <li
                          key={item.id}
                          className="list-group-item d-flex justify-content-between align-items-center"
                        >
                          <div>
                            {item.name} - ₹{item.price} × {item.qty} ={" "}
                            <strong>₹{item.qty * item.price}</strong>
                          </div>
                          <div className="d-flex align-items-center gap-2">
                            <button
                              type="button"
                              className="btn btn-outline-danger btn-sm"
                              onClick={() => decreaseQty(item)}
                            >
                              –
                            </button>
                            <span>{item.qty}</span>
                            <button
                              type="button"
                              className="btn btn-outline-success btn-sm"
                              onClick={() => addToCart(item)}
                            >
                              +
                            </button>
                          </div>
                        </li>
                      ))}
                    </ul>
                    <h5 className="text-end">Total: ₹{totalPrice}</h5>
                  </div>
                )}
              </form>
            </div>

            {/* Footer */}
            <div className="modal-footer">
              <h6 className="pe-2">
                <span className="text-danger">CONTACT US</span> FOR QUERIES +914657546546
              </h6>
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                Close
              </button>
              <button type="submit" form="orderForm" className="btn btn-primary">
                Send
              </button>
            </div>
          </div>
        </div>
      </div>



      {/* Toast */}
      {showToast && (
        <div
          className="toast align-items-center text-bg-success border-0 show position-fixed bottom-0 end-0 m-3"
          role="alert"
        >
          <div className="d-flex">
            <div className="toast-body">{toastMessage}</div>
            <button
              type="button"
              className="btn-close btn-close-white me-2 m-auto"
              onClick={() => setShowToast(false)}
             >

            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Shop;

